import { alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { UiAlpha } from '../../../styles/ui-alpha';

type Params = { selected: boolean };

export const useStyles = makeStyles<Params>()((theme, { selected }) => ({
  root: {
    marginLeft: theme.spacing(0.5),
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: theme.spacing(2.75),
    height: theme.spacing(2.75),
    padding: theme.spacing(0, 0.75),
    borderRadius: 999,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 500,
    lineHeight: 1,
    flexShrink: 0,
    boxSizing: 'border-box',
    ...(selected
      ? {
          backgroundColor: alpha(theme.palette.common.white, 0.92),
          color: theme.palette.primary.main,
          boxShadow: `inset 0 0 0 1px ${alpha(theme.palette.common.white, 0.35)}`,
        }
      : {
          backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Tint),
          color: theme.palette.primary.main,
        }),
  },
}));
